import module from 'viaticos/module.js'

export const schema = {
  revisarEnviado: 'boolean',
  revisarFecha: 'datetime',
  solicitud_id: 'number',
}

export class ViaticosViaticoRevisarService {
  constructor ($http) {
    this.$http = $http
  }

  put (solicitudId) {
    return this.$http.put('api/viaticos/viaticos/viatico/revisar', {}, {
      params: {
        solicitud_id: solicitudId,
      },
      schema,
    })
  }
}

module.service('ViaticosViaticoRevisarService', ViaticosViaticoRevisarService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Revisar.js